import { ErrorHandler, Injectable } from '@angular/core';
import { LocalizationExtendService } from 'src/app/service/localization/localization.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private localizationService: LocalizationExtendService) { }

  async handleError(error: any): Promise<void> {
    const chunkFailedMessage = /Loading chunk .*failed.*[.js\\)]/;
    const notiContent = await this.localizationService.getLocalization('WARR::Share:thereIsNewVersion');

    if (chunkFailedMessage.test(error.message)) {
      if (confirm(notiContent)) {
        window.location.reload();
      }
    }
  }
}